export const TIME_GAP = [
    {
        name: "1m",
        value: 1,
    },
    {
        name: "5m",
        value: 2,
    },
    // {
    //     name: '15m',
    //     value: 3,
    //     //min: 15,
    // },
    {
        name: "1h",
        value: 5,
        //min: 60,
    },
    // {
    //     name: '4h',
    //     value: 6,
    //     //min: 60 * 4,
    // },
    {
        name: "1d",
        value: 7,
        //min: 60 * 24,
    },
    {
        name: "1w",
        value: 8,
        //min: 60 * 24 * 7,
    },
];

export const K_TYPE = [
    {
        name: "Pro",
        value: "pro",
    },
    {
        name: "Lite",
        value: "lite",
    },
];

export const BTN_ARR = [
    {
        name: "MACD",
        code: 0,
    },
    {
        name: "KDJ",
        code: 1,
    },
    {
        name: "RSI",
        code: 2,
    },
    {
        name: "WR",
        code: 3,
    },
];

export const BTN_OBJ = {
    MACD: "MACD",
    KDJ: "KDJ",
    RSI: "RSI",
    WR: "WR",
};

export const BTN_ARR2 = [
    {
        name: "MA",
        code: 0,
    },
    {
        name: "BOLL",
        code: 1,
    },
];

export const BTN_OBJ2 = {
    MA: "MA",
    BOLL: "BOLL",
};
